import { AttentionFilled } from '@pay-com/icons'
import { UniversalMarkdown } from 'components/UniversalMarkdown'
import { TaskDetail } from 'generated/graphql'
import { capitalize, startCase } from 'lodash-es'
import { useTranslation } from 'react-i18next'
import { twMerge } from 'tailwind-merge'

type TaskRequestReasonProps = {
  taskDetails?: TaskDetail
  compact?: boolean
}

export const TaskRequestReason = ({
  taskDetails,
  compact
}: TaskRequestReasonProps) => {
  const { t } = useTranslation()

  return (
    <div
      className={twMerge(
        'grid gap-1.5 rounded-sm bg-gray-50 p-3.5',
        compact && 'gap-0 bg-transparent p-0'
      )}
    >
      <div className="flex gap-1.5">
        {!compact && (
          <AttentionFilled stroke="#fff" className="size-5" color="#000" />
        )}
        <span className={twMerge('text-sm', compact && 'font-semibold')}>
          {capitalize(startCase(taskDetails?.requestReason ?? '')) ||
            t('tasks.invalidInformation')}
        </span>
      </div>
      <div className="text-sm text-gray-600">
        <UniversalMarkdown>{taskDetails?.description || ''}</UniversalMarkdown>
      </div>
    </div>
  )
}
